import { useContactService } from 'services';

export const getMembership = () => {
  const myMemberships = useContactService.getState().myMemberships;
  return myMemberships.data?.[0];
};
